var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex-column py-6 px-9 gray-0-bkg prelative" },
    [
      _c("header", { staticClass: "mb-4" }, [
        _c("p", { staticClass: "fs-6 my-0 lh-reset" }, [
          _vm._v(_vm._s(_vm.$l10n.__("Récapitulatif")))
        ]),
        _vm._v(" "),
        _vm.isSale
          ? _c(
              "span",
              { staticClass: "grey fs-3" },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$l10n.__("Envoyé à")) +
                    "\n            "
                ),
                _vm.contact.name && _vm.contact.forename
                  ? [
                      _vm._v(
                        _vm._s(_vm.contact.forename) +
                          " " +
                          _vm._s(_vm.contact.name)
                      )
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.contact.email
                  ? [_vm._v(" - " + _vm._s(_vm.contact.email))]
                  : _vm._e()
              ],
              2
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "article",
        [
          _c(
            "div",
            {
              staticClass: "flex-row mb-4",
              class: !_vm.isSale && _vm.isMonthly ? "ai-center" : "flex-bottom"
            },
            [
              _c("SaasIcon", {
                staticClass: "gray-100",
                attrs: { icon: "sellsyCloud", width: "35", height: "24" }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "capitalize fs-5 ml-2" }, [
                _vm._v(_vm._s(_vm.$filters.lowerCase(_vm.licencePlan)))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex-item-right fs-3" }, [
                _c("span", { staticClass: "bold" }, [
                  _vm._v(_vm._s(_vm.labelPlan))
                ]),
                _vm._v(" "),
                !_vm.isSale && _vm.isMonthly
                  ? _c("span", { staticClass: "fs-2 block aright lh-reset" }, [
                      _vm._v(_vm._s(_vm.$l10n.__("Engagement 12 mois")))
                    ])
                  : _vm._e()
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm._t("licences")
        ],
        2
      ),
      _vm._v(" "),
      _c("span", { staticClass: "separator block my-3" }),
      _vm._v(" "),
      _c(
        "article",
        { staticClass: "flex-row jc-space" },
        [_vm._t("subtotal")],
        2
      ),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      _c(
        "article",
        { staticClass: "cart-recap-total" },
        [
          _c("span", { staticClass: "separator block my-3" }),
          _vm._v(" "),
          _vm._t("total"),
          _vm._v(" "),
          _vm._t("actions")
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }